/* eslint-disable react/no-deprecated */
/* eslint-disable no-restricted-globals */
import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import InputAdornment from '@material-ui/core/InputAdornment';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import 'rc-time-picker/assets/index.css';
import NativeSelect from '@material-ui/core/NativeSelect';
import 'react-datepicker/dist/react-datepicker.css';
import CheckIcon from '@material-ui/icons/Check';
import CloseIcon from '@material-ui/icons/Close';
import _ from 'lodash';
import { mainColor, settings, SAVE_BUTTON_TEXT } from '../../constants';
import Input from '../Input';
import Paper from '../Paper';
import Spinner from '../Spinner';
import Button from '../Button';
import BackButton from '../BackButton';
import * as actions from '../../actions/index';
import ReactPhoneInput from 'react-phone-input-2';
import 'react-phone-input-2/lib/style.css'; // Import the styles
import {
  handleChangeInfoContact,
  handleSubmitData,
  initDataConfig,
  handleChangeManagementFeeRef,
  onFocusOnBlur,
  handleChangeCanceledFees,
  handleChangePhoneNumber
} from './GeneralConfig.services';
import { styles } from './GeneralConfig.styles';
import { formatPhoneService, phoneNumberMinLength } from '../../utils/shopUtils';
import { isStringNotNull } from '../../utils/tools';
import { hasExternalIntegration } from 'src/utils/externalIntegration';

const INITIAL_STATE = {
  data: {},
  isLoading: false,
  deliveryFee: {},
  techs: {},
  validationMessage: {
    email: null,
    number: null,
    fee: null,
    managementFeeRef: null,
    deliveryFeeRef: null
  }
};
class GeneralConfig extends Component {
  state = INITIAL_STATE;

  componentDidMount() {
    initDataConfig(this.props, this);
  }

  componentWillReceiveProps(nextProps) {
    const { configurations: oldConfigs } = this.props;
    const { configurations } = nextProps;
    const { support = {}, configuration = {} } = configurations;
    const { refs = {} } = configuration;
    const { charges = {} } = refs;
    const { deliveryFeeRef = {}, managementFeeRef = {} } = charges;
    const {
      support: oldSupport = {},
      configuration: oldConfig = {}
    } = oldConfigs;
    const { refs: oldRef = {} } = oldConfig;
    const { charges: oldCharges = {} } = oldRef;
    const {
      deliveryFeeRef: oldDeliveryFeeRef = {},
      managementFeeRef: oldManagementFeeRef = {}
    } = oldCharges;
    if (
      !_.isEqual(oldDeliveryFeeRef, deliveryFeeRef) ||
      !_.isEqual(oldManagementFeeRef, managementFeeRef) ||
      !_.isEqual(oldSupport, support)
    ) initDataConfig(nextProps, this)
  }

  renderConfigInfoContact = () => {
    const { classes } = this.props;
    const { data = {}, validationMessage = {} } = this.state;
    const { support = {} } = data;
    const { email = {} } = validationMessage;

    let value = formatPhoneService(this, support.number);

    return (
      <div className={`row m-0 p-3 `}>
        <div className='col-sm-4 mt-2'>
          <p className={classes.boldText}>Contact :</p>
        </div>
        <div className='col-sm-8'>
          <Input
            margin='dense'
            id='email'
            label='Email'
            type='text'
            value={support.email || ''}
            fullWidth
            classes={{ input: classes.underlineInput }}
            error={email && email.text === 'is-invalid'}
            onFocus={event => onFocusOnBlur(event, true, this)}
            onBlur={event => onFocusOnBlur(event, false, this)}
            onChange={e => handleChangeInfoContact(e, this)}
            InputProps={{
              endAdornment: email && (
                <InputAdornment position='end' disablePointerEvents='true'>
                  {email.text === 'is-invalid' ? (
                    <CloseIcon
                      className={classes.inputAdorment}
                      style={{ color: mainColor.colorRed }}
                    />
                  ) : (
                    email.isFocused && <CheckIcon className={classes.inputAdorment} />
                  )}
                </InputAdornment>
              )
            }}
          />
          <p className='text-muted mb-2'>Numéro de téléphone</p>
          <ReactPhoneInput
            placeholder='Numéro de téléphone'
            id='number'
            countryCodeEditable={false}
            inputStyle={{
              width: '100%',
              boxSizing: 'border-box'
            }}
            country='fr'
            value={value}
            preferredCountries={['fr', 'mc']}
            regions={['europe']}
            inputClass={`${(this.isPhoneIncorrect || !isStringNotNull(value)) ? 'is-invalid' : ''}`}
            ref={node => (this.phoneInput = node)}
            onChange={(phone) => handleChangePhoneNumber(formatPhoneService(this, phone), this)}
            isValid={(value, countryCode) => {
              if (this.phoneInput) {
                const { dialCode, iso2 } = countryCode;
                const minLength = phoneNumberMinLength(iso2);
                this.isPhoneIncorrect = (value.length - dialCode.length < minLength) || (value && value.toString().replace(dialCode, '')[0] === '0');
              }
              return true;
            }}
          />
          {(this.isPhoneIncorrect || !isStringNotNull(value)) && (
            <div className="invalid-feedback-block">Veuillez fournir un téléphone valide</div>
          )}
        </div>
      </div>
    );
  };

  renderFeesRef = () => {
    const { classes } = this.props;
    const { data } = this.state;
    const { managementFeeRef: managementRef = {}, deliveryFeeRef: deliveryRef = {} } = data;
    return (
      <div className={`row m-0 p-3 ${classes.root}`}>
        <div className='col-sm-4 mt-2'>
          <p className={classes.boldText}>Références des frais :</p>
        </div>
        <div className='col-sm-8'>
          <Input
            margin='dense'
            label='Référence des frais de gestion'
            id='managementFeeRef'
            fullWidth
            value={managementRef.ref || ''}
            classes={{ input: classes.underlineInput }}
            onFocus={event => onFocusOnBlur(event, true, this)}
            onBlur={event => onFocusOnBlur(event, false, this)}
            onChange={event => handleChangeManagementFeeRef(event, this)}
          />
          <Input
            margin='dense'
            id='deliveryFeeRef'
            label='Référence des frais de livraison'
            value={deliveryRef.ref || ''}
            classes={{ input: classes.underlineInput }}
            fullWidth
            onChange={event => handleChangeManagementFeeRef(event, this)}
            onFocus={event => onFocusOnBlur(event, true, this)}
            onBlur={event => onFocusOnBlur(event, false, this)}
          />
        </div>
      </div>
    );
  };
  renderConfigCancelFees = () => {
    const { classes } = this.props;
    const { data = {} } = this.state;
    const { cancelFee = {} } = data;

    return (
      <div className={`row m-0 p-3 ${classes.root}`}>
        <div className='col-sm-4 mt-2'>
          <p className={classes.boldText}>Frais d'annulation :</p>
        </div>
        <div className='d-flex flex-column col-sm-8'>
          <NativeSelect
            id='type'
            className='pr-1 '
            value={cancelFee.type || '€'}
            onChange={event => handleChangeCanceledFees(event, this)}
          >
            <option key={0} value='€'>
              Euros
            </option>
            <option key={1} value='%'>
              % de la commande
            </option>
          </NativeSelect>
          <Input
            margin='dense'
            id='value'
            type='number'
            classes={{ input: classes.underlineInput }}
            fullWidth
            value={cancelFee.value < 0 ? 0 : cancelFee.value}
            onChange={event => handleChangeCanceledFees(event, this)}
            InputProps={{
              endAdornment: <InputAdornment position='end'>{cancelFee.type}</InputAdornment>
            }}
          />
        </div>
      </div>
    );
  };

  render() {
    const { classes, history = {} } = this.props;
    const { isLoading } = this.state;
    return (
      <div className='p-4'>
        <BackButton
          className='p-0'
          onClick={() => history.goBack()}
          title={settings.general.text}
          subtitle={settings.general.description}
        />

        <Paper className={`col-12 px-0 my-3 ${classes.paperStyle}`}>
          {this.renderConfigInfoContact()}
          {this.renderConfigCancelFees()}
          {hasExternalIntegration() && this.renderFeesRef()}
          <div className='d-flex w-100 justify-content-center justify-content-sm-end align-items-center p-4'>
            <div className={`px-sm-${isLoading ? 5 : 0} `}>
              {isLoading ? (
                <Spinner size={30} />
              ) : (
                <Button
                  color='primary'
                  onClick={e => handleSubmitData(e, this)}
                  className='btn-primary'
                >
                  <div className='row justify-content-center align-items-center mr-0 ml-0'>
                    <p className='mx-0'>{SAVE_BUTTON_TEXT}</p>
                  </div>
                </Button>
              )}
            </div>
          </div>
        </Paper>
      </div>
    );
  }
}

function mapStateToProps({ firebaseRealTime, sidebar }) {
  const { shop } = firebaseRealTime;
  const { sidebarCollapse } = sidebar;

  return {
    configurations: shop,
    sidebarCollapse
  };
}
export default connect(mapStateToProps, actions)(withStyles(styles)(withRouter(GeneralConfig)));
